export default "__VITE_ASSET__D8NQim$Q__"